import { DateTime } from 'luxon';

import {
  LMS_CLASS_FILTER_DATETIME_FORMAT,
  parseLmsClassFilterDateTime,
} from 'components/ClassesV2/utils/lmsClassDateTime';
import { LiveClassModality } from 'types/class';
import { LiveClassStatus } from 'types/liveClass';

export const LMS_CLASS_DEFAULT_SORT_BY = 'startDate';
export const LMS_CLASS_DEFAULT_SORT = 'desc';

/** Legacy `/classes` ClassList.defaultProps filter defaults for instructor parity. */
export const LMS_CLASS_LIST_DEFAULT_MODALITIES = [
  LiveClassModality.ILT,
  LiveClassModality.OS,
  LiveClassModality.VT,
  LiveClassModality.OSVT,
] as const;

export const LMS_CLASS_LIST_DEFAULT_STATUSES = [
  LiveClassStatus.Delivered,
  LiveClassStatus.GuaranteedToRun,
  LiveClassStatus.Scheduled,
  LiveClassStatus.OnHold,
] as const;

export function getLmsClassListDefaultEndDateEnd(
  now: DateTime = DateTime.now(),
): string {
  return now.plus({ weeks: 2 }).toFormat('yyyy-MM-dd');
}

export function getLmsClassListDefaultEndDateTime(
  now: DateTime = DateTime.now(),
): string {
  return now
    .plus({ weeks: 2 })
    .endOf('day')
    .toFormat(LMS_CLASS_FILTER_DATETIME_FORMAT);
}

const normalizeFilterValues = (values: string[]): string[] =>
  values.map((value) => value.toLowerCase()).sort();

export function isDashboardDefaultModalities(modalities: string[]): boolean {
  const normalized = normalizeFilterValues(modalities);
  const defaults = normalizeFilterValues([
    ...LMS_CLASS_LIST_DEFAULT_MODALITIES,
  ]);
  return (
    normalized.length === defaults.length &&
    normalized.every((value, index) => value === defaults[index])
  );
}

export function isDashboardDefaultStatuses(statuses: string[]): boolean {
  const normalized = normalizeFilterValues(statuses);
  const defaults = normalizeFilterValues([...LMS_CLASS_LIST_DEFAULT_STATUSES]);
  return (
    normalized.length === defaults.length &&
    normalized.every((value, index) => value === defaults[index])
  );
}

export function isEndDateFilterAtDefault(
  endDateTime: string | null,
  now: DateTime = DateTime.now(),
): boolean {
  if (!endDateTime) {
    return false;
  }

  const parsed = parseLmsClassFilterDateTime(endDateTime);
  if (!parsed) {
    return false;
  }

  const defaultEnd = DateTime.fromFormat(
    getLmsClassListDefaultEndDateEnd(now),
    'yyyy-MM-dd',
  ).endOf('day');
  return DateTime.fromJSDate(parsed).hasSame(defaultEnd, 'minute');
}

export function resolveClassListSidepanelEndDate(
  endDateTime: string | null,
): Date | undefined {
  return parseLmsClassFilterDateTime(endDateTime ?? undefined);
}
